var map = {
	"./115.svg": "f14d",
	"./aliyun_disk.svg": "27da",
	"./baidu_netdisk.svg": "70fe",
	"./bluetooth.svg": "4949",
	"./ding_talk.svg": "f1a0",
	"./enterprise_wx.svg": "d173",
	"./ftp.svg": "d20a",
	"./http.svg": "fde5",
	"./https.svg": "a9f9",
	"./lark.svg": "c921",
	"./mCloud.svg": "3ce1",
	"./printer.svg": "704d",
	"./qq.svg": "19a7",
	"./quark.svg": "cd5b",
	"./removablemedia.svg": "ce7f",
	"./share.svg": "25aa",
	"./smtp.svg": "a85c",
	"./smtps.svg": "b353",
	"./tim.svg": "4410",
	"./weiyun.svg": "a377",
	"./wx.svg": "3a4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "daf7";